import {
  IMGIX_BASE_URL,
  IMGIX_IMAGE_FORMATE,
  IMGIX_IMAGE_QUALITY,
  IMGIX_PRODUCTION_BASE_URL
} from '~shared/constants/imgix.constant';
import { akamaiImageSrcset } from '~shared/utils/image.utils';
import { AKAMAI_BASE_URL, AKAMAI_POLICIES, AKAMAI_PP_BASE_URL } from '~shared/constants/akamai.constants';

export namespace CategoryImagesUtil {

  export function getCategoryImageSrc(id: string, height: number, width: number, isAkamaiEnable = false): string {
    if (isAkamaiEnable) {
      return getAkamaiCategoryImageSrc(id, width);
    }

    const imgixBaseUrl = IMGIX_BASE_URL() || IMGIX_PRODUCTION_BASE_URL;
    const imageUrl = buildImageUrl(imgixBaseUrl, id, height, width);

    return `${imageUrl} 1x`;
  }

  export function getCategoryImageSrcSet(id: string, height: number, width: number, isAkamaiEnable = false): string {
    if (isAkamaiEnable) {
      return getAkamaiCategoryImageSrc(id, width);
    }

    const imgixBaseUrl = IMGIX_BASE_URL() || IMGIX_PRODUCTION_BASE_URL;
    const imageUrl = buildImageUrl(imgixBaseUrl, id, height, width);

    return `${imageUrl} 1x, ${imageUrl}&dpr=2 2x, ${imageUrl}&dpr=3 3x`;
  }

  function getAkamaiCategoryImageSrc(id: string, width: number): string {
    const akamaiBaseUrl = AKAMAI_BASE_URL() || AKAMAI_PP_BASE_URL;
    const src = `${akamaiBaseUrl}/category_image/${id}.jpg`;

    return akamaiImageSrcset({
      src,
      width,
      policy: AKAMAI_POLICIES.TOP_NAVIGATION_CATEGORY_BUBBLE
    });
  }

  function buildImageUrl(baseUrl: string, id: string, height: number, width: number): string {
    return `${baseUrl}/category_image/${id}.jpg` +
      `?h=${height}&w=${width}&q=${IMGIX_IMAGE_QUALITY}` +
      `&${IMGIX_IMAGE_FORMATE}=format&fit=max`;
  }
}
